<template>
  <div class="product-add" v-loading="loading">
    <el-form size="mini" :model="editForm" ref="editForm" label-position="right" label-width="100px">
      <el-form-item label="方案标题：" prop="solutionTitle" :rules="{required: true,message: '请输入方案名称'}"
                    style="width: 40%">
        <el-input v-model="editForm.solutionTitle"
                  placeholder="请输入方案标题"></el-input>
      </el-form-item>
      <el-form-item label="方案分类：" style="width: 40%" prop="typeId"
                    :rules="{required: true,message: '请选择方案分类'}">
        <treeselect v-model="editForm.typeId" :options="tableData"
                    :normalizer="normalizer"
                    placeholder="请选择分类"/>

      </el-form-item>
      <el-form-item label="方案封面：">
        <div style="width: 120px;height: 80px;  overflow: hidden;border: 1px dashed #dddddd;border-radius: 5px;">
          <div class="item img-select"
               style="width: 120px;height: 80px;display: flex;justify-content: center;align-items: center;"
               @click="openProductUpload('image', 'header')">
            <i class="el-icon-plus" v-if="!editForm.coverPath"></i>
            <img
              style="max-height: 100%; max-width: 100%;"
              v-img-url="editForm.coverPath" v-if="editForm.coverPath"/>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="方案作物：" prop="cropList"
                    :rules="{required: true,message: '请添加方案作物'}">
        <el-tag :key="item.id" v-for="(item,index) in editForm.cropList" closable
                :disable-transitions="false"
                class="margin-right-10"
                @close="handleClose(editForm.cropList,index)">{{ item }}
        </el-tag>
        <el-input
          class="input-new-tag"
          v-if="inputVisible"
          v-model="inputValue"
          ref="saveCropInput"
          size="mini"
          @keyup.enter.native="handleInputConfirm"
          @blur="handleInputConfirm"
        ></el-input>
        <el-button size="mini" type="primary" @click="onCropChoose">添加作物</el-button>
      </el-form-item>
      <el-form-item label="方案时期：" prop="periodIds">
        <el-tag :key="item.id" v-for="(item,index) in editForm.periodList" closable
                :disable-transitions="false"
                class="margin-right-10"
                @close="handleClose(editForm.periodList,index)">{{ item }}
        </el-tag>
        <el-input
          class="input-new-tag"
          v-if="inputPeriodVisible"
          v-model="inputPeriodValue"
          ref="savePeriodInput"
          size="mini"
          @keyup.enter.native="handlePeriodInputConfirm"
          @blur="handlePeriodInputConfirm"
        ></el-input>
        <el-button size="mini" type="primary" @click="onPeriodChoose">添加时期</el-button>
      </el-form-item>
      <el-form-item label="防治对象：" prop="periodIds">
        <el-tag :key="item.id" v-for="(item,index) in editForm.preventionTargetList" closable
                :disable-transitions="false"
                class="margin-right-10"
                @close="handleClose(editForm.preventionTargetList,index)">{{ item }}
        </el-tag>
        <el-input
          class="input-new-tag"
          v-if="inputTargetVisible"
          v-model="inputTargetValue"
          ref="saveTargetInput"
          size="mini"
          @keyup.enter.native="handleTargetInputConfirm"
          @blur="handleTargetInputConfirm"
        ></el-input>
        <el-button size="mini" type="primary" @click="onTargetChoose">添加防治对象</el-button>
      </el-form-item>
<!--      <el-form-item label="方案说明：" style="width: 40%">-->
<!--        <el-input size="mini" type="textarea" rows="4" resize="false" v-model="editForm.solutionDesc"-->
<!--                  placeholder="请输入方案说明"></el-input>-->
<!--      </el-form-item>-->

      <el-form-item label="容器水量：" prop="waterConsumption" style="width: 40%"
                    :rules="{required: true,message: '请添加容器水量'}">
        <el-input size="mini" v-model="editForm.waterConsumption" @blur="onWaterConSunptionBlurChange"
                  placeholder="请输入容器水量">
          <el-select slot="append" v-model="editForm.unit" style="width: 100px" @change="onWaterConSunptionBlurChange">
            <el-option label="公斤" value="公斤"></el-option>
            <el-option label="斤" value="斤"></el-option>
          </el-select>
        </el-input>
      </el-form-item>

      <el-form-item label="方案产品：" prop="cropSolutionProductList"
                    :rules="{required: true,message: '请添加方案产品'}">
        <el-table border size="mini" :data="editForm.cropSolutionProductList">
          <el-table-column label="序号" type="index" width="50" align="center"/>
          <el-table-column label="目标" prop="target" align="center" width="150px">
            <template slot-scope="scope">
              <el-input size="mini" v-model="scope.row.target"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="productName" label="产品" show-overflow-tooltip min-width="150px">
            <template slot-scope="scope">
              <el-input size="mini" v-model="scope.row.productName"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="成分" prop="ingredient" align="center" min-width="150px">
            <template slot-scope="scope">
              <el-input size="mini" v-model="scope.row.ingredient"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="剂型" prop="dosage" align="center" width="150px">
            <template slot-scope="scope">
              <el-input size="mini" v-model="scope.row.dosage"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="用药量/兑水量" prop="spec" align="center" width="280px">
            <template slot-scope="scope">
              <el-input size="mini" v-model="scope.row.spec" style="max-width: 170px"
                        @blur="onItemSpecBlurChange(scope.row)">
                <el-select slot="append" size="mini" v-model="scope.row.unit" style="width: 70px">
                  <el-option label="g" value="g"></el-option>
                  <el-option label="ml" value="ml"></el-option>
                </el-select>
              </el-input>
              /{{ editForm.waterConsumption }}{{ editForm.unit }}
            </template>
          </el-table-column>
          <el-table-column label="稀释倍数" prop="dilutionRatio" align="center" width="150px">
            <template slot-scope="scope">
              <div>
                <el-input-number size="mini" :controls="false" v-model="scope.row.dilutionRatio" :min="0"
                                 style="width: 100%"
                                 @blur="ondilutionRatioBlurChange(scope.row)"
                                 :precision="2"></el-input-number>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="120px">
            <template slot="header" slot-scope="scope">
              <el-button
                type="text"
                plain
                size="mini"
                @click="handleProductAdd"
              >添加产品
              </el-button>
            </template>
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="handleProductUpdate(scope.row,scope.$index)"
              >修改
              </el-button>
              <el-button
                size="mini"
                type="text"
                @click="handleDelete(scope.$index)"
              >删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>

      </el-form-item>
      <el-form-item label="应用图例：">
        <div class="draggable-list">
          <draggable class="wrapper" v-model="editForm.attachLists">
            <transition-group>
              <div class="item" v-for="(item, index) in editForm.attachLists" :key="item">
                <img v-img-url="item.filePath"/>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i
                  class="el-icon-close"></i></a>
              </div>
            </transition-group>
          </draggable>
          <div class="item img-select" @click="openProductUpload('image', 'imageList')"><i class="el-icon-plus"></i>
          </div>
        </div>
      </el-form-item>

      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="addSubmit" :loading="loading">发布</el-button>
      </div>
    </el-form>
    <Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">
      上传图片
    </Upload>
    <!--选择商品-->
    <ProductSelect :isProduct="isproduct" :islist="islist" :dataType="0" @closeDialog="closeProductDialogFunc($event)">
    </ProductSelect>
  </div>
</template>

<script>
import Upload from '@/components/file/Upload'
import ProductSelect from '@/components/product/Product'
import CropSolutionApi from '@/api/cropsolution.js'
import draggable from 'vuedraggable'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  name: 'edit',
  components: {
    draggable,
    Upload,
    ProductSelect,
    Treeselect
  },
  data () {
    return {
      loading: false,
      dialogTitle: '',
      dialogVisible: false,
      solutionId: 0,
      editForm: {
        solutionTitle: '',
        coverId: 0,
        coverPath: '',
        typeId: undefined,
        cropList: [],
        periodList: [],
        preventionTargetList: [],
        solutionDesc: '',
        waterConsumption: 40,
        unit: '公斤',
        remark: '',
        attachLists: [],
        cropSolutionProductList: []
      },
      isProductUpload: false,
      file_name: 'image',
      config: {},
      inputVisible: false,
      inputValue: '',
      inputPeriodVisible: false,
      inputPeriodValue: '',
      inputTargetVisible: false,
      inputTargetValue: '',
      /*是否打开产品弹出层*/
      isproduct: false,
      islist: true,
      selRow: null,
      selIndex: undefined,
      tableData: []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.getSolutionTypeList()
      this.solutionId = parseInt(this.$route.query.solutionId || 0)
      this.getCropSolutionDetail()
    },
    getCropSolutionDetail () {
      CropSolutionApi.cropSolutionDetail({id: this.solutionId}, true).then(res => {
        this.editForm = res.data
      })
    },
    getSolutionTypeList () {
      let self = this
      CropSolutionApi.getCropSolutionType({}, true).then(res => {
        self.tableData = res.data || []
      }).catch(error => {
      })
    },
    normalizer (node) {
      let item = {
        id: node.id,
        label: node.typeName,
      }
      if (node.children && node.children.length) {
        item.children = node.children
      } else {
        item.children = undefined
      }
      return item
    },
    addSubmit () {
      let self = this
      self.$refs.editForm.validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(self.editForm))
          CropSolutionApi.editCropSolution(params, true).then(res => {
            if (res.code === 1) {
              self.$router.back(-1)
            }
            self.$message.info(res.msg)
          })
        }
      })
    },

    returnProductImgsFunc (e) {
      if (e != null) {
        // 兼容后端
        if (e.length > 0) {
          if (this.file_name === 'imageList') {
            this.editForm.attachLists = this.editForm.attachLists.concat(e)
          } else if (this.file_name === 'header') {
            this.editForm.coverPath = e[0].filePath
            this.editForm.coverId = e[0].fileId
          }
        }
      }
      this.isProductUpload = false
    },
    /*删除商品图片*/
    deleteImg (index) {
      this.editForm.attachLists.splice(index, 1)
    },
    /*打开上传图片*/
    openProductUpload: function (file_type, file_name) {
      this.file_name = file_name
      if (this.file_name === 'imageList') {
        this.config = {
          total: 9,
          fileType: file_type
        }
      } else if (this.file_name === 'header') {
        this.config = {
          total: 1,
          fileType: file_type
        }
      }

      this.isProductUpload = true
    },
    handleClose (list, index) {
      list.splice(index, 1)
    },
    handleProductAdd () {
      this.islist = true
      this.isproduct = true
    },
    handleInputConfirm () {
      let inputValue = this.inputValue
      if (inputValue) {
        this.editForm.cropList.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    onCropChoose () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveCropInput.$refs.input.focus()
      })
    },
    handlePeriodInputConfirm () {
      let inputValue = this.inputPeriodValue
      if (inputValue) {
        this.editForm.periodList.push(inputValue)
      }
      this.inputPeriodVisible = false
      this.inputPeriodValue = ''
    },
    onPeriodChoose () {
      this.inputPeriodVisible = true
      this.$nextTick(_ => {
        this.$refs.savePeriodInput.$refs.input.focus()
      })
    },
    handleTargetInputConfirm () {
      let inputValue = this.inputTargetValue
      if (inputValue) {
        this.editForm.preventionTargetList.push(inputValue)
      }
      this.inputTargetVisible = false
      this.inputTargetValue = ''
    },
    onTargetChoose () {
      this.inputTargetVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTargetInput.$refs.input.focus()
      })
    },
    closeProductDialogFunc (e) {
      if (e.type !== 'error') {
        let proList = JSON.parse(JSON.stringify(this.editForm.cropSolutionProductList)) || []
        const map = proList.reduce((acc, item) => {
          acc.set(item.productId, item)
          return acc
        }, new Map())
        if (this.islist) {
          if (e.params && e.params.length) {
            e.params.map(item => {
              let productId = item.productId
              let split = item.productName.split(' ')
              let productName = split.slice(0, 2).join(' ')
              let tempList = split.slice(2, 3)
              let ingredient = tempList && tempList.length ? tempList[0] : ''
              let searchInfo = split.find(item => {
                return item.endsWith('剂')
              })
              let dosage = ''
              if (searchInfo) {
                dosage = searchInfo || ''
              }
              let spec = undefined
              let unit = undefined
              let sku = item.sku
              if (sku && sku.length) {
                let specName = sku[0].specName
                let regex = /\d+[\d\w\u4e00-\u9fa5]+/g
                let matches = specName.match(regex)
                if (matches && matches.length) {
                  let result = matches[0].match(/(\d+)(.*)/)
                  let secUnit = result[2]
                  if (secUnit === 'kg' || secUnit === '千克' || secUnit === '公斤') {
                    spec = parseInt(result[1], 10) * 1000
                    unit = 'g'
                  } else if (secUnit === '斤') {
                    spec = parseInt(result[1], 10) * 500
                    unit = 'g'
                  } else if (secUnit === '克' || secUnit === 'g') {
                    spec = parseInt(result[1], 10)
                    unit = 'g'
                  } else if (secUnit === 'L' || secUnit === '升') {
                    spec = parseInt(result[1], 10) * 1000
                    unit = 'ml'
                  } else if (secUnit === 'ml' || secUnit === '毫升') {
                    spec = parseInt(result[1], 10)
                    unit = 'ml'
                  }
                }
              }
              let dilutionRatio = undefined
              if (spec && unit && this.editForm.unit && this.editForm.waterConsumption) {
                let allUnit = this.editForm.unit
                let allWaterConsumption = 0
                if ('公斤' === allUnit) {
                  allWaterConsumption = this.editForm.waterConsumption * 1000
                } else if ('斤' === allUnit) {
                  allWaterConsumption = this.editForm.waterConsumption * 500
                }
                dilutionRatio = this._Decimal.div(allWaterConsumption, spec).toDecimalPlaces(2)
              }
              if (!map.has(productId)) {
                let pItem = {
                  target: '',
                  productId: item.productId,
                  productName: productName,
                  image: item.image,
                  productPrice: item.productPrice,
                  linePrice: item.linePrice,
                  productSales: item.productSales,
                  dosage: dosage || '',
                  ingredient: ingredient || '',
                  spec: spec,
                  unit: unit,
                  usageNum: undefined,
                  dilutionRatio: dilutionRatio
                }
                this.editForm.cropSolutionProductList.push(pItem)
              }
            })
          }
        } else {
          let item = e.params
          let productId = item.productId
          let split = item.productName.split(' ')
          let productName = split.slice(0, 2).join(' ')
          let tempList = split.slice(2, 3)
          let ingredient = tempList && tempList.length ? tempList[0] : ''
          let searchInfo = split.find(item => {
            return item.endsWith('剂')
          })
          let dosage = ''
          if (searchInfo) {
            dosage = searchInfo || ''
          }
          let spec = undefined
          let unit = undefined
          let sku = item.sku
          if (sku && sku.length) {
            let specName = sku[0].specName
            let regex = /\d+[\d\w\u4e00-\u9fa5]+/g
            let matches = specName.match(regex)
            if (matches && matches.length) {
              let result = matches[0].match(/(\d+)(.*)/)
              let secUnit = result[2]
              if (secUnit === 'kg' || secUnit === '千克' || secUnit === '公斤') {
                spec = parseInt(result[1], 10) * 1000
                unit = 'g'
              } else if (secUnit === '斤') {
                spec = parseInt(result[1], 10) * 500
                unit = 'g'
              } else if (secUnit === '克' || secUnit === 'g') {
                spec = parseInt(result[1], 10)
                unit = 'g'
              } else if (secUnit === 'L' || secUnit === '升') {
                spec = parseInt(result[1], 10) * 1000
                unit = 'ml'
              } else if (secUnit === 'ml' || secUnit === '毫升') {
                spec = parseInt(result[1], 10)
                unit = 'ml'
              }
            }
          }
          let dilutionRatio = undefined
          if (spec && unit && this.editForm.unit && this.editForm.waterConsumption) {
            let allUnit = this.editForm.unit
            let allWaterConsumption = 0
            if ('公斤' === allUnit) {
              allWaterConsumption = this.editForm.waterConsumption * 1000
            } else if ('斤' === allUnit) {
              allWaterConsumption = this.editForm.waterConsumption * 500
            }
            dilutionRatio = this._Decimal.div(allWaterConsumption, spec).toDecimalPlaces(2)
          }
          if (!map.has(productId)) {
            Object.assign(this.selRow, {
              target: '',
              productId: item.productId,
              productName: productName,
              image: item.image,
              productPrice: item.productPrice,
              linePrice: item.linePrice,
              productSales: item.productSales,
              dosage: dosage || '',
              ingredient: ingredient || '',
              spec: spec,
              unit: unit,
              usageNum: undefined,
              dilutionRatio: dilutionRatio
            })
          } else {
            console.log(this.selRow)
            if (this.selRow.productId !== item.productId) {
              this.editForm.cropSolutionProductList.splice(this.selIndex, 1)
            }
          }
        }
      }
      this.isproduct = false
    },
    handleProductUpdate (row, index) {
      this.islist = false
      this.selRow = row
      this.selIndex = index
      this.isproduct = true
    },
    handleDelete (index) {
      this.editForm.cropSolutionProductList.splice(index, 1)
    },
    /*取消*/
    cancelFunc () {
      this.$router.back(-1)
    },
    onWaterConSunptionBlurChange () {
      let allUnit = this.editForm.unit
      let allWaterConsumption = 0
      if ('公斤' === allUnit) {
        allWaterConsumption = this.editForm.waterConsumption * 1000
      } else if ('斤' === allUnit) {
        allWaterConsumption = this.editForm.waterConsumption * 500
      }
      if (this.editForm.cropSolutionProductList && this.editForm.cropSolutionProductList.length) {
        for (let i = 0; i < this.editForm.cropSolutionProductList.length; i++) {
          let item = this.editForm.cropSolutionProductList[i]
          let spec = item.spec
          let unit = item.unit
          if (spec && unit && allWaterConsumption) {
            item.dilutionRatio = this._Decimal.div(allWaterConsumption, spec).toDecimalPlaces(2)
          } else {
            item.dilutionRatio = undefined
          }
        }
      }
    },
    onItemSpecBlurChange (item) {
      let allUnit = this.editForm.unit
      let allWaterConsumption = 0
      if ('公斤' === allUnit) {
        allWaterConsumption = this.editForm.waterConsumption * 1000
      } else if ('斤' === allUnit) {
        allWaterConsumption = this.editForm.waterConsumption * 500
      }
      let spec = item.spec
      let unit = item.unit
      if (spec && unit && allWaterConsumption) {
        item.dilutionRatio = this._Decimal.div(allWaterConsumption, spec).toDecimalPlaces(2)
      } else {
        item.dilutionRatio = undefined
      }
    },
    ondilutionRatioBlurChange (item) {
      let allUnit = this.editForm.unit
      let allWaterConsumption = 0
      if ('公斤' === allUnit) {
        allWaterConsumption = this.editForm.waterConsumption * 1000
      } else if ('斤' === allUnit) {
        allWaterConsumption = this.editForm.waterConsumption * 500
      }
      let dilutionRatio = item.dilutionRatio
      let unit = item.unit
      if (dilutionRatio && unit && allWaterConsumption) {
        item.spec = this._Decimal.div(allWaterConsumption, dilutionRatio).toDecimalPlaces(2)
      } else {
        item.spec = undefined
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.product-add {
  padding-bottom: 100px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 80px;
  height: 80px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

.input-new-tag {
  width: 90px;
  margin-right: 10px;
  vertical-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/crop/solution/period/edit.vue